/**
 * The bio is embedded in a preview iframe (express-setup's phone mockup, the
 * template picker, the AI bio preview) when its URL carries `?source=iframe`.
 * The embedder owns the query param; the bio side reads it to drop owner-only
 * chrome that has no meaning inside a preview.
 *
 * Callers must be client-side and read this AFTER a client-only gate (auth
 * resolution, a mount effect) — the value isn't available during SSR, so
 * branching on it in a first-paint render path would hydration-mismatch.
 */
export const kIframeSourceParam = 'source';
export const kIframeSourceValue = 'iframe';

export const isIframeMode = (): boolean => {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get(kIframeSourceParam) === kIframeSourceValue;
};
